import { render, staticRenderFns } from "./RevenueRecruiterWise.vue?vue&type=template&id=62025074&"
import script from "./RevenueRecruiterWise.vue?vue&type=script&lang=js&"
export * from "./RevenueRecruiterWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports